import React, { Component, Fragment } from 'react';
import ReactPlaceholder from 'react-placeholder';
import {
  Form,
  InputPlaceholder,
  TextareaPlaceholder,
  Can,
  SectionDivider,
  ActionsWrapper,
  Row
} from '@contently/toolkit';

import TagSelect from '../forms/tag-select';
import CampaignSelect from '../forms/campaign_select';
import StoryFormatSelect from '../forms/story_format_select';
import ContentStrategySection from '../forms/content_strategy_section';
import FieldTemplatesCheckboxes from '../forms/checkboxes/field_templates_checkboxes';
import ErrorNotice from '../forms/error_notice';

class BriefForm extends Component {
  static anyFetching(fetchingMap) {
    const selectsStillFetching = Object.keys(fetchingMap).filter(select => fetchingMap[select]);

    return selectsStillFetching.length > 0;
  }

  constructor(props) {
    super(props);
    this.state = {
      fetching: {
        parentFetching: props.streamingData || false,
        storyFormats: false,
        campaigns: false,
        contentStrategy: false,
        fieldTemplates: false,
        tags: false
      },
      optionFetchError: false
    };
  }

  componentDidMount() {
    const { fetchUserPermissions, streamingData, accountId } = this.props;

    const accountIdFromEditOrNew = streamingData ? streamingData.accountId : accountId;

    fetchUserPermissions(accountIdFromEditOrNew);
  }

  componentWillReceiveProps(nextProps) {
    const { streamingData, setValues } = this.props;

    if (streamingData !== nextProps.streamingData) {
      setValues(nextProps.streamingData);
      this.handleFetching('parentFetching', nextProps.streamingData.parentFetching);
    }
  }

  handleSelectedFieldTemplatesChange = data => {
    const { setFieldValue } = this.props;
    setFieldValue('fieldTemplates', data.filter(f => f.checked).map(f => f.value));
  };

  handleError = () => {
    this.setState({
      optionFetchError: true
    });
  };

  handleFetching = (select, stillFetching) => {
    const { fetching } = this.state;
    const fetchingState = { ...fetching };
    fetchingState[select] = stillFetching;
    this.setState({
      fetching: fetchingState
    });
  };

  render() {
    const {
      permissionsFetching,
      handleSubmit,
      handleChange,
      handleBlur,
      values,
      errors,
      touched,
      isSubmitting,
      permissionFetchError,
      errors: { submitFailedMsg }
    } = this.props;
    const { brandProfileId, fieldTemplates } = values;
    const { fetching, optionFetchError } = this.state;
    const stillFetching = BriefForm.anyFetching(fetching);

    let form = (
      <form onSubmit={handleSubmit} data-parsley-excluded="true">
        <SectionDivider>
          <Row>
            <ReactPlaceholder
              showLoadingAnimation
              customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
              ready={!BriefForm.anyFetching(fetching)}
            >
              <Form.Label required htmlFor="name">
                Name
              </Form.Label>
              <Form.ErrorWrapper touched={touched.name} error={errors.name}>
                <Form.Input
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  name="name"
                  id="name"
                  placeholder="Give your brief template a name"
                  required
                />
              </Form.ErrorWrapper>
            </ReactPlaceholder>
          </Row>

          <Row>
            <StoryFormatSelect
              {...this.props}
              fetching={stillFetching}
              onFetching={this.handleFetching}
              onError={this.handleError}
            />
          </Row>

          <Row>
            <ReactPlaceholder
              showLoadingAnimation
              customPlaceholder={<TextareaPlaceholder wrapperClass="row" withLabel />}
              ready={!BriefForm.anyFetching(fetching)}
            >
              <Form.Label htmlFor="description">Details</Form.Label>
              <Form.ErrorWrapper touched={touched.description} error={errors.description}>
                <Form.MarkdownPreviewTextarea
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                  name="description"
                  id="description"
                  placeholder="Describe the story you want"
                />
              </Form.ErrorWrapper>
            </ReactPlaceholder>
          </Row>

          <Row>
            <Can permission={`publications.${brandProfileId}.campaigns.list`}>
              <CampaignSelect
                {...this.props}
                fetching={stillFetching}
                brandProfileId={brandProfileId}
                onFetching={this.handleFetching}
                onError={this.handleError}
              />
            </Can>
          </Row>

          <Can permission={`publications.${brandProfileId}.content_strategy.list`}>
            <ContentStrategySection
              {...this.props}
              fetching={stillFetching}
              brandProfileId={`${brandProfileId}`}
              onFetching={this.handleFetching}
              onError={this.handleError}
            />
          </Can>

          <Can permission={`publications.${brandProfileId}.custom_fields.list`}>
            <FieldTemplatesCheckboxes
              fetching={stillFetching}
              onChange={this.handleSelectedFieldTemplatesChange}
              brandProfileId={brandProfileId}
              selected={fieldTemplates}
              onFetching={this.handleFetching}
              onError={this.handleError}
            />
          </Can>

          <Row>
            <Can permission={`publications.${brandProfileId}.tags.list`}>
              <TagSelect
                {...this.props}
                label="Tags"
                id="tags"
                placeholder="Select Tags"
                brandProfileId={brandProfileId}
                fetching={stillFetching}
                onFetching={this.handleFetching}
                onError={this.handleError}
              />
            </Can>
          </Row>
        </SectionDivider>

        {!stillFetching && (
          <ActionsWrapper>
            <Form.CancelLinkButton href={`/publications/${brandProfileId}/brief_templates`} />
            <Form.ButtonWithProgress type="submit" disabled={isSubmitting} variant="primary">
              Submit
            </Form.ButtonWithProgress>
          </ActionsWrapper>
        )}
      </form>
    );

    if (permissionFetchError || optionFetchError || submitFailedMsg) {
      const defaultMsg = 'There was an error loading your form.';
      form = <ErrorNotice msg={submitFailedMsg || defaultMsg} />;
    }

    if (permissionsFetching) {
      form = null;
    }

    return <Fragment>{form}</Fragment>;
  }
}

export default BriefForm;



// WEBPACK FOOTER //
// ./app/javascript/app/components/brief_templates/form.jsx